// components/ParticularModal.js
import React, { useState, useEffect } from 'react';
import {
  Modal,
  Form,
  Input,
  Switch,
  Select,
  Space,
  Button,
  message,
  Row,
  Col,
  Card,
  DatePicker,
  Alert,
  Spin,
  Tag,
} from 'antd';
import {
  ScanOutlined,
  SignatureOutlined,
  UserOutlined,
  IdcardOutlined,
  CalendarOutlined,
  PhoneOutlined,
  MailOutlined,
  SaveOutlined,
  CloseOutlined,
  ReloadOutlined,
  HomeOutlined,
  CreditCardOutlined,
  TeamOutlined,
  FileTextOutlined
} from '@ant-design/icons';
import axios from 'axios';
import dayjs from 'dayjs';

import { BASE_URL } from '../utils/constants';

const { Option } = Select;
const { TextArea } = Input;

const ParticularModal = ({
  visible,
  onClose,
  onSuccess,
  codigoHotel,
  numReserva,
  linea,
  numOcupante,
  codParti = null,
  nombreReserva = '',
  telefonoReserva = '',
  emailReserva = '',
  fechaEntrada = null,
  tipoReserva = 'Hotel'
}) => {

        // console.log(" datos ParticularModal => ",numReserva,linea,numOcupante,codigoHotel);


  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [scanning, setScanning] = useState(false);
  const [currentCodParti, setCurrentCodParti] = useState(null);
  const [isNew, setIsNew] = useState(true);

  // Estados para datos de combos
  const [paises, setPaises] = useState([]);
  const [provincias, setProvincias] = useState([]);
  const [tiposDocumento, setTiposDocumento] = useState([]);
  const [tiposSexo, setTiposSexo] = useState([]);
  const [tiposCliente, setTiposCliente] = useState([]);
  const [tiposSegmentacion, setTiposSegmentacion] = useState([]);

  const renderFlag = (codigoISO) => {
    if (!codigoISO || codigoISO.trim() === '') {
      return <span style={{ marginRight: '4px' }}>🌍</span>;
    }
    return <span className={`fi fi-${codigoISO.toLowerCase()}`} style={{ marginRight: '4px' }} />;
  };

  // Cargar datos de combos al montar
  useEffect(() => {
    if (visible) {
      fetchAuxData();
    }
  }, [visible]);

  // Cargar datos del particular cuando cambia el código
  useEffect(() => {
    if (visible && codParti && codParti !== '0' && codParti !== '') {
      loadParticular(codParti);
      setIsNew(false);
    } else {
      initializeFromReserva();
      setIsNew(true);
    }
  }, [visible, codParti]);

  // Cargar datos auxiliares (combos)
  const fetchAuxData = async () => {
    const token = localStorage.getItem('token');
    
    const endpoints = [
      { key: 'paises', url: `${BASE_URL}/api/particularesGC/aux/paises`, setter: setPaises },
      { key: 'provincias', url: `${BASE_URL}/api/particularesGC/aux/provincias`, setter: setProvincias },
      { key: 'tiposDocumento', url: `${BASE_URL}/api/particularesGC/aux/tipos-documento`, setter: setTiposDocumento },
      { key: 'tiposSexo', url: `${BASE_URL}/api/particularesGC/aux/tipos-sexo`, setter: setTiposSexo },
      { key: 'tiposCliente', url: `${BASE_URL}/api/particularesGC/aux/tipos-cliente`, setter: setTiposCliente },
      { key: 'tiposSegmentacion', url: `${BASE_URL}/api/particularesGC/aux/tipos-segmentacion`, setter: setTiposSegmentacion },
    ];

    for (const endpoint of endpoints) {
      try {
        const response = await axios.get(endpoint.url, {
          headers: { Authorization: `Bearer ${token}` },
          timeout: 10000
        });
        const data = response.data.data || [];
        endpoint.setter(data);
      } catch (error) {
        console.error(`❌ Error cargando ${endpoint.key}:`, error.message);
        endpoint.setter([]);
      }
    }
  };

  // Cargar un particular existente
  const loadParticular = async (codigo) => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${BASE_URL}/api/particulares/${codigo}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const data = response.data.data;
      setCurrentCodParti(data.Codigo);

      const formValues = {
        Codigo: data.Codigo,
        Nombre1: data.nombre1 || '',
        Apellido1: data.apellido1 || '',
        Apellido2: data.apellido2 || '',
        NIF: data.NIF || '',
        NumeroSoporte: data.NumeroSoporte || '',
        Direccion: data.Direccion || '',
        Poblacion: data.Poblacion || '',
        CodPostal: data.CodPostal || '',
        Provincia: data.Provincia || '',
        Pais: data.Pais || '',
        LugarNacimiento: data.LugarNacimiento || '',
        FechaNacimiento: data.FechaNacimiento ? dayjs(data.FechaNacimiento) : null,
        FechaExpedicion: data.FechaExpedicion ? dayjs(data.FechaExpedicion) : null,
        TipoDocumento: data.TipoDocumento || '',
        Sexo: data.Sexo || '',
        TipoCliente: data.TipoCliente || '',
        TipoSegmentacion: data.TipoSegmentacion || '',
        Telefono1: data.Telefono1 || '',
        Telefono2: data.Telefono2 || '',
        Fax: data.Fax || '',
        EMail: data.EMail || '',
        Visa: data.visa || '',
        CadTarjeta: data.CadTarjeta ? dayjs(data.CadTarjeta) : null,
        Notas: data.notas || '',
        ListarDatos: Boolean(data.ListarDatos),
        MarcaMailing: Boolean(data.MarcaMailing)
      };

      form.setFieldsValue(formValues);
      setIsNew(false);

    } catch (error) {
      console.error('❌ Error cargando particular:', error);
      message.error('Error al cargar los datos del particular');
    } finally {
      setLoading(false);
    }
  };

  // Inicializar con datos de la reserva
  const initializeFromReserva = () => {
    let nombre1 = '';
    let apellido1 = '';
    let apellido2 = '';

    form.resetFields();

    if (nombreReserva) {
      const parts = nombreReserva.trim().split(' ');
      if (parts.length === 1) {
        nombre1 = parts[0];
      } else if (parts.length === 2) {
        nombre1 = parts[0];
        apellido1 = parts[1];
      } else if (parts.length >= 3) {
        nombre1 = parts[0];
        apellido1 = parts[1];
        apellido2 = parts.slice(2).join(' ');
      }
    }

    form.setFieldsValue({
      Codigo: '',
      Nombre1: nombre1,
      Apellido1: apellido1,
      Apellido2: apellido2,
      Telefono1: telefonoReserva || '',
      EMail: emailReserva || '',
      ListarDatos: true,
      MarcaMailing: false,
    });

    setCurrentCodParti(null);
  };

  // Guardar particular
  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      const token = localStorage.getItem('token');

      const formData = {
        ...values,
        FechaNacimiento: values.FechaNacimiento ? values.FechaNacimiento.format('YYYY-MM-DD') : null,
        FechaExpedicion: values.FechaExpedicion ? values.FechaExpedicion.format('YYYY-MM-DD') : null,
        CadTarjeta: values.CadTarjeta ? values.CadTarjeta.format('YYYY-MM-DD') : null,
      };

      setSaving(true);

      let response;
      if (currentCodParti && !isNew) {
        response = await axios.put(
          `${BASE_URL}/api/particulares/${currentCodParti}`,
          formData,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        await updateReservaLinea(currentCodParti);

        message.success('Particular actualizado correctamente');
      } else {
        if (!formData.Codigo) {
          const lastCode = await getLastCode();
          console.log(" lastCode => ",lastCode);
          
          formData.Codigo = String(Number(lastCode) + 1).padStart(5, '0');
        }
        response = await axios.post(
          `${BASE_URL}/api/particulares`,
          formData,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        message.success('Particular creado correctamente');
      }

      const newCodParti = response.data.data.Codigo;
      console.log(" newCodParti => ",newCodParti);
      
      await updateReservaLinea(newCodParti);

      if (onSuccess) {
        onSuccess(newCodParti, response.data.data);
      }

      onClose();

    } catch (error) {
      console.error('❌ Error guardando particular:', error);
      message.error(error.response?.data?.error || 'Error al guardar los datos');
    } finally {
      setSaving(false);
    }
  };

  const getLastCode = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${BASE_URL}/api/particulares/codigos/proximo-codigo`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      
      const data = response.data.data || [];

      console.log(" data => ",data.proximoCodigo);
      
      return data.proximoCodigo;

      return '0';
    } catch (error) {
      console.error('❌ Error obteniendo último código:', error);
      return '0';
    }
  };

  const updateReservaLinea = async (codParti) => {
    try {
      const token = localStorage.getItem('token');
      const values = form.getFieldsValue();
      const nombreCompleto = `${values.Nombre1 || ''} ${values.Apellido1 || ''} ${values.Apellido2 || ''}`.trim();

      const payload = {
        CodParti: codParti,
        Nombre: nombreCompleto,
        Telefono: values.Telefono1 || '',
        Email: values.EMail || '',
        NIF: values.NIF || '',
        Nacion: values.Pais || '',
        Provincia: values.Provincia || '',
      };

      await axios.put(
        `${BASE_URL}/api/reservas/${numReserva}/linea/${linea}/ocupante/${numOcupante}/particular`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

    } catch (error) {
      console.error('❌ Error actualizando línea de reserva:', error);
    }
  };

  const handleScan = async () => {
    setScanning(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 1500));
      const response = await axios.post(`${BASE_URL}/api/particulares/scan`, {});
      const data = response.data.data;

      if (data) {
        const formValues = {
          TipoDocumento: data.TipoDocumento || '',
          NIF: data.NIF || '',
          Nombre1: data.Nombre1 || '',
          Apellido1: data.Apellido1 || '',
          Apellido2: data.Apellido2 || '',
          FechaNacimiento: data.FechaNacimiento ? dayjs(data.FechaNacimiento) : null,
          FechaExpedicion: data.FechaExpedicion ? dayjs(data.FechaExpedicion) : null,
          LugarNacimiento: data.LugarNacimiento || '',
          Direccion: data.Direccion || '',
          Poblacion: data.Poblacion || '',
          CodPostal: data.CodPostal || '',
          Provincia: data.Provincia || '',
          Pais: data.Pais || '',
          Sexo: data.Sexo || '',
        };

        form.setFieldsValue(formValues);
        message.success('Datos cargados desde el escáner');
      }

    } catch (error) {
      console.error('❌ Error en escáner:', error);
      message.warning('No se pudo leer el documento. Verifique el escáner.');
    } finally {
      setScanning(false);
    }
  };

  const handleSignature = () => {
    message.info('Función de firma (simulada)');
  };

const handleReiniciarParticular = () => {
    form.resetFields();
    setIsNew(true);
    message.info('Datos reiniciados');
  };

  const handleReset = () => {
    if (codParti && codParti !== '0' && codParti !== '') {
      loadParticular(codParti);
    } else {
      initializeFromReserva();
    }
    message.info('Datos restablecidos');
  };

  const renderContent = () => {
    if (loading) {
      return (
        <div style={{ textAlign: 'center', padding: '40px 0' }}>
          <Spin size="large" />
          <p style={{ marginTop: 16 }}>Cargando datos del particular...</p>
        </div>
      );
    }

    return (
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          ListarDatos: true,
          MarcaMailing: false
        }}
        size="small"
      >
        {/* === BARRA DE ACCIONES === */}
        <Row gutter={8} style={{ marginBottom: 8 }}>
          <Col span={24}>
            <Space size="small">
              <Button
                icon={<ScanOutlined />}
                onClick={handleScan}
                loading={scanning}
                size="small"
              >
                Leer Documento
              </Button>
              <Button
                icon={<SignatureOutlined />}
                onClick={handleSignature}
                size="small"
              >
                Firma
              </Button>
              <Button
                icon={<ReloadOutlined />}
                onClick={handleReset}
                size="small"
              >
                Refrescar
              </Button>
              <Button
                icon={<ReloadOutlined />}
                onClick={handleReiniciarParticular}
                size="small"
              >
                Reiniciar particular
              </Button>              
            </Space>
          </Col>
        </Row>

        {/* === CONTEXTO DE LA RESERVA ===
        <Alert
          message="Contexto de la reserva"
          description={
            <Space size="small" wrap>
              <Tag color="blue" style={{ fontSize: 11 }}>R: {numReserva}</Tag>
              <Tag color="green" style={{ fontSize: 11 }}>L: {linea}</Tag>
              <Tag color="orange" style={{ fontSize: 11 }}>O: {numOcupante}</Tag>
              {fechaEntrada && (
                <Tag color="purple" style={{ fontSize: 11 }}>
                  <CalendarOutlined /> {dayjs(fechaEntrada).format('DD/MM/YYYY')}
                </Tag>
              )}
              {codParti && codParti !== '0' && (
                <Tag color="cyan" style={{ fontSize: 11 }}>Código: {codParti}</Tag>
              )}
            </Space>
          }
          type="info"
          showIcon
          style={{ marginBottom: 8, padding: '4px 12px' }}
        /> */}

        {/* === SECCIÓN 1: DOCUMENTO DE IDENTIDAD === */}
        <Card 
          title={<><IdcardOutlined /> Documento</>} 
          size="small"
          style={{ marginBottom: 6 }}
        >
          <Row gutter={[8, 0]}>
            <Col xs={24} sm={8}>
              <Form.Item
                name="TipoDocumento"
                label="Tipo"
                rules={[{ required: true, message: 'Seleccione el tipo' }]}
                style={{ marginBottom: 4 }}
              >
                <Select placeholder="Tipo" allowClear size="small">
                  {tiposDocumento.map(t => (
                    <Option key={t.value} value={t.value}>{t.label}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item
                name="NIF"
                label="DNI / Pasaporte"
                rules={[{ required: true, message: 'Ingrese el documento' }]}
                style={{ marginBottom: 4 }}
              >
                <Input placeholder="12345678Z" prefix={<IdcardOutlined />} size="small" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item
                name="NumeroSoporte"
                label="Nº Soporte"
                style={{ marginBottom: 4 }}
              >
                <Input placeholder="Número de soporte" size="small" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[8, 0]}>
            <Col xs={24} sm={12}>
              <Form.Item
                name="FechaExpedicion"
                label="Fecha Expedición"
                style={{ marginBottom: 4 }}
              >
                <DatePicker
                  style={{ width: '100%' }}
                  format="DD/MM/YYYY"
                  placeholder="Seleccionar"
                  suffixIcon={<CalendarOutlined />}
                  size="small"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name="FechaNacimiento"
                label="Fecha Nacimiento"
                rules={[{ required: true, message: 'Ingrese la fecha' }]}
                style={{ marginBottom: 4 }}
              >
                <DatePicker
                  style={{ width: '100%' }}
                  format="DD/MM/YYYY"
                  placeholder="Seleccionar"
                  suffixIcon={<CalendarOutlined />}
                  size="small"
                />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        {/* === SECCIÓN 2: DATOS PERSONALES === */}
        <Card 
          title={<><UserOutlined /> Datos Personales</>} 
          size="small"
          style={{ marginBottom: 6 }}
        >
          <Row gutter={[8, 0]}>
            <Col xs={24} sm={4}>
              <Form.Item
                name="Codigo"
                label="Código"
                // rules={[
                //   { pattern: /^[A-Z0-9]{1,5}$/, message: 'Máx. 5 caracteres' }
                // ]}
                style={{ marginBottom: 4 }}
              >
                <Input
                  placeholder="Código"
                  disabled={!isNew && currentCodParti}
                  prefix={<UserOutlined />}
                  maxLength={5}
                  style={{ textTransform: 'uppercase' }}
                  size="small"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={7}>
              <Form.Item
                name="Nombre1"
                label="Nombre"
                rules={[{ required: true, message: 'Ingrese el nombre' }]}
                style={{ marginBottom: 4 }}
              >
                <Input placeholder="Nombre" size="small" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={7}>
              <Form.Item
                name="Apellido1"
                label="Primer Apellido"
                rules={[{ required: true, message: 'Ingrese el apellido' }]}
                style={{ marginBottom: 4 }}
              >
                <Input placeholder="Apellido 1" size="small" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={6}>
              <Form.Item
                name="Apellido2"
                label="Segundo Apellido"
                style={{ marginBottom: 4 }}
              >
                <Input placeholder="Apellido 2" size="small" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[8, 0]}>
            <Col xs={24} sm={8}>
              <Form.Item
                name="Sexo"
                label="Sexo"
                rules={[{ required: true, message: 'Seleccione el sexo' }]}
                style={{ marginBottom: 4 }}
              >
                <Select placeholder="Sexo" allowClear size="small">
                  {tiposSexo.map(t => (
                    <Option key={t.value} value={t.value}>{t.label}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item
                name="LugarNacimiento"
                label="Lugar de Nacimiento"
                style={{ marginBottom: 4 }}
              >
                <Input placeholder="Ciudad" size="small" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item
                name="Pais"
                label="Nacionalidad"
                style={{ marginBottom: 4 }}
              >
                <Select placeholder="País" allowClear showSearch size="small">
                  {paises.map(pais => (
                    <Option key={pais.value} value={pais.value}>
                      {renderFlag(pais.CodigoISO)}
                      {pais.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Card>

        {/* === SECCIÓN 3: DIRECCIÓN Y CONTACTO (fusionados) === */}
        <Card 
          title={<><HomeOutlined /> Dirección y Contacto</>} 
          size="small"
          style={{ marginBottom: 6 }}
        >
          <Row gutter={[8, 0]}>
            <Col xs={24} sm={12}>
              <Form.Item
                name="Direccion"
                label="Domicilio"
                style={{ marginBottom: 4 }}
              >
                <Input placeholder="Calle, número, piso" size="small" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name="Poblacion"
                label="Población"
                style={{ marginBottom: 4 }}
              >
                <Input placeholder="Ciudad" size="small" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[8, 0]}>
            <Col xs={24} sm={6}>
              <Form.Item
                name="Provincia"
                label="Provincia"
                style={{ marginBottom: 4 }}
              >
                <Select placeholder="Provincia" allowClear showSearch size="small">
                  {provincias.map(p => (
                    <Option key={p.value} value={p.value}>{p.label}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={6}>
              <Form.Item
                name="CodPostal"
                label="Código Postal"
                style={{ marginBottom: 4 }}
              >
                <Input placeholder="Código postal" size="small" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={6}>
              <Form.Item
                name="Telefono1"
                label="Teléfono"
                style={{ marginBottom: 4 }}
              >
                <Input placeholder="Teléfono" prefix={<PhoneOutlined />} size="small" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={6}>
              <Form.Item
                name="EMail"
                label="E-Mail"
                rules={[{ type: 'email', message: 'Email inválido' }]}
                style={{ marginBottom: 4 }}
              >
                <Input placeholder="email@dominio.com" prefix={<MailOutlined />} size="small" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[8, 0]}>
            <Col xs={12} sm={6}>
              <Form.Item
                name="ListarDatos"
                label="Listar"
                valuePropName="checked"
                style={{ marginBottom: 4 }}
              >
                <Switch checkedChildren="Sí" unCheckedChildren="No" size="small" />
              </Form.Item>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Item
                name="MarcaMailing"
                label="Mailing"
                valuePropName="checked"
                style={{ marginBottom: 4 }}
              >
                <Switch checkedChildren="Sí" unCheckedChildren="No" size="small" />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        {/* === SECCIÓN 4: VISA / TARJETA ===
        <Card 
          title={<><CreditCardOutlined /> Visa / Tarjeta</>} 
          size="small"
          style={{ marginBottom: 6 }}
        >
          <Row gutter={[8, 0]}>
            <Col xs={24} sm={12}>
              <Form.Item
                name="Visa"
                label="Número de Visa"
                style={{ marginBottom: 4 }}
              >
                <Input placeholder="Número de tarjeta" size="small" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name="CadTarjeta"
                label="Fecha Caducidad"
                style={{ marginBottom: 4 }}
              >
                <DatePicker
                  style={{ width: '100%' }}
                  format="MM/YYYY"
                  placeholder="MM/YYYY"
                  picker="month"
                  suffixIcon={<CalendarOutlined />}
                  size="small"
                />
              </Form.Item>
            </Col>
          </Row>
        </Card> */}

        {/* === SECCIÓN 5: CLASIFICACIÓN === */}
        <Card 
          title={<><TeamOutlined /> Clasificación</>} 
          size="small"
          style={{ marginBottom: 6 }}
        >
          <Row gutter={[8, 0]}>
            <Col xs={24} sm={12}>
              <Form.Item
                name="TipoCliente"
                label="Tipo de Cliente"
                style={{ marginBottom: 4 }}
              >
                <Select placeholder="Tipo" allowClear size="small">
                  {tiposCliente.map(t => (
                    <Option key={t.value} value={t.value}>{t.label}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name="TipoSegmentacion"
                label="Segmentación"
                style={{ marginBottom: 4 }}
              >
                <Select placeholder="Segmentación" allowClear size="small">
                  {tiposSegmentacion.map(t => (
                    <Option key={t.value} value={t.value}>{t.label}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Card>

        {/* === SECCIÓN 6: OBSERVACIONES === */}
        <Card 
          title={<><FileTextOutlined /> Observaciones</>} 
          size="small"
          style={{ marginBottom: 6 }}
        >
          <Row gutter={[8, 0]}>
            <Col span={24}>
              <Form.Item
                name="Notas"
                label="Notas"
                style={{ marginBottom: 4 }}
              >
                <TextArea
                  rows={2}
                  placeholder="Observaciones adicionales"
                  maxLength={255}
                  showCount
                  style={{ fontSize: 12 }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        {/* === ALERTA DE INFORMACIÓN === */}
        <Alert
          message="💡 Los campos con * son obligatorios. Use el escáner para leer el documento."
          type="info"
          showIcon
          style={{ padding: '4px 12px' }}
        />
      </Form>
    );
  };

  return (
    <Modal
      title={
        <Space size="small" wrap style={{ fontSize: 14 }}>
          <UserOutlined />
          <span>
            {isNew ? 'Nuevo Particular' : 'Editar Particular'}
            {codParti && codParti !== '0' && ` - ${codParti}`}
          </span>
          <Tag color="blue" style={{ fontSize: 11 }}>
            Reserva {numReserva} Línea {linea} Ocupante {numOcupante}
          </Tag>
        </Space>
      }
      open={visible}
      onCancel={onClose}
      width={900}
      footer={[
        <Button key="cancel" onClick={onClose} icon={<CloseOutlined />} size="small">
          Cancelar
        </Button>,
        <Button
          key="save"
          type="primary"
          onClick={handleSave}
          loading={saving}
          icon={<SaveOutlined />}
          size="small"
        >
          {isNew ? 'Crear' : 'Guardar'}
        </Button>
      ]}
      bodyStyle={{ 
        maxHeight: 'calc(100vh - 160px)', 
        overflowY: 'auto', 
        padding: '12px 16px' 
      }}
      destroyOnClose
    >
      {renderContent()}
    </Modal>
  );
};

export default ParticularModal;